<ng-container *ngIf="deviceDetails && deviceDetails?.type?.toLocaleLowerCase() !== financial">
  <div class="row m-t-xl">
    <div class="col-12">
      <h3 [innerHtml]="pdpStaticContent?.features"></h3>
    </div>
  </div>
  <div class="row">
    <p class="col-12 m-t-lg" [innerHtml]="deviceDetails.description"></p>
    <div class="row col-12 m-l-lg">
      <div class="m-t-lg">
        <ul class="bulleted-list">
          <li class="p" *ngFor="let item of features">{{ item?.description }}</li>
        </ul>
      </div>
    </div>
    <div class="col-12 m-t-lg">
      <p class="legal">{{ deviceDetails?.legalText }}</p>
    </div>
  </div>

  <div class="row m-t-xl">
    <div class="col-12">
      <hr class="divider" />
    </div>
  </div>
</ng-container>
